"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyData = {
    id: 0,
    code: '',
    name: '',
    samplesCount: 0,
    projectsCount: 0,
};
class Distributor {
    constructor(data = emptyData) {
        this.id = data.id || emptyData.id;
        this.code = data.code || emptyData.code;
        this.name = data.name || emptyData.name;
        this.samplesCount = data.samplesCount || emptyData.samplesCount;
        this.projectsCount = data.projectsCount || emptyData.projectsCount;
    }
}
exports.default = Distributor;
